import script from "./zhibanbiaodetail.vue?vue&type=script&setup=true&lang=js"
export * from "./zhibanbiaodetail.vue?vue&type=script&setup=true&lang=js"

import "./zhibanbiaodetail.vue?vue&type=style&index=0&id=33047d3e&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33047d3e"]])

export default __exports__